import { styled } from '@mui/material';
import { Colors } from 'library';
import { Stack, Title } from 'library/ui';

export const HeroBand = styled(Stack)({
    background: `linear-gradient(135deg, ${Colors.primary} 0%, ${Colors.primaryDarkened} 100%)`,
    padding: '48px 24px',
});

export const HeroTitle = styled(Title)({
    fontSize: 40,
});
